module.exports = __webpack_public_path__ + "static/concepts-15c07f4a3744b0db6ad459d22037b483.png";